import React from 'react';
import { useDispatch } from 'react-redux';
import { redirectToUrl } from '@gumtree/shared/src/util/browser-service';
import { qaAttribute } from '@gumtree/ui-library/src/utils/qa-service';

import type { SrpUseDispatch } from '../../../../reducers';
import { trackGA4FiltersDiffThunk } from '../../../../reducers/current-filter-states';
import {
    StyledCategory,
    StyledCategoryName,
    StyledCheckIcon,
    StyledChevronIcon,
    StyledCategories,
} from './ancestors.style';
import { FilterItemWithState } from '../../../filters/util';

const Ancestors = ({
    ancestorCategoriesProcessed,
}: {
    ancestorCategoriesProcessed: FilterItemWithState[];
}) => {
    const dispatch = useDispatch() as SrpUseDispatch;

    return (
        <StyledCategories>
            {ancestorCategoriesProcessed.map(({ label, value, uri, isChecked }) => {
                return (
                    <StyledCategory key={value}>
                        <StyledCategoryName
                            {...qaAttribute('ancestor-category')}
                            isSelected={isChecked}
                            key={value}
                            onClick={() => {
                                dispatch(trackGA4FiltersDiffThunk({
                                    updatedSearchFilters: { listingCategory: value },
                                    searchFilters: { search_category: value },
                                }));
                                redirectToUrl(uri);
                            }}
                            href={isChecked ? undefined : uri}
                        >
                            {!isChecked && <StyledChevronIcon type="chevron-l" size="smallest" />}
                            {label}
                        </StyledCategoryName>
                        {isChecked && <StyledCheckIcon type="check" />}
                    </StyledCategory>
                );
            })}
        </StyledCategories>
    );
};

export default Ancestors;
